<script setup lang="ts">
const nuxtApp = useNuxtApp()

const {
  data: searchQueries,
  status,
  error,
} = useAsyncData(`search-trending`, () => $fetch(`/api/search/trending/`), {
  getCachedData(key) {
    return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
  },
})

const queries = computed(() => {
  if (!searchQueries.value?.length) return []

  return searchQueries.value.map((query) => ({
    route: { name: 'explore', query: { query } },
    title: query,
  }))
})
</script>

<template>
  <section v-if="!error" class="space-y-5">
    <SectionTitle>Trending Searches</SectionTitle>

    <div class="space-x-2 overflow-x-scroll hidden-scroll whitespace-nowrap">
      <template v-if="status === 'pending'">
        <div
          v-for="(_, index) in 10"
          :key="index"
          class="inline-flex bg-zeno-gray-light rounded-full h-8 px-4 pt-px pb-px min-w-24 animate-pulse"
        />
      </template>

      <template v-else>
        <TagLink v-for="query in queries" :key="query.title" :route="query.route">
          {{ query.title }}
        </TagLink>
      </template>
    </div>
  </section>
</template>

<style scoped></style>
